import React from 'react';
import { Card, Col, Progress, Row } from 'antd';

const metricToPercent = (value, fallback) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return fallback;
  return Math.max(0, Math.min(100, n));
};

const SystemHealthCard = ({ systemHealth = {} }) => {
  const cpu = metricToPercent(systemHealth?.cpuUsage, 0);
  const memory = metricToPercent(systemHealth?.memoryUsage, 0);
  const disk = metricToPercent(systemHealth?.diskUsage, 0);
  return (
    <Card title="System Health">
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={8}>
          CPU
          <Progress percent={cpu} />
        </Col>
        <Col xs={24} sm={8}>
          Memory
          <Progress percent={memory} />
        </Col>
        <Col xs={24} sm={8}>
          Disk
          <Progress percent={disk} />
        </Col>
      </Row>
    </Card>
  );
};

export default SystemHealthCard;

